// --- GSAP等の設定 ----
// GSAP
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
// import { ScrollToPlugin } from "gsap/ScrollToPlugin.js";
// import { CustomEase } from "gsap/CustomEase.js"; // カスタムイージング作成が必要なときは使用

gsap.registerPlugin(ScrollTrigger);




document.addEventListener('DOMContentLoaded', function(event) {

// --- scrollEffect ---
  if (document.querySelector('.js-slideup')) {
    document.querySelectorAll('.js-slideup').forEach(elm => {

      ScrollTrigger.create({
        toggleActions: 'play pause resume reset',
        trigger: elm,
        start: `top bottom`,
        onEnter: function() {
          elm.classList.remove('init');
        },
        onLeaveBack: function() {
          elm.classList.add('init');
        },
      });
    });
  }

  
// --- タイプ風エフェクト ----  
  setTypeEffect();
  function setTypeEffect() {
    // スクロールトリガー配列
    // const stArray = [];
    
    if (document.querySelector('.js-type .js-type-line')) {
      // 準備（1文字ずつspanで括る
      document.querySelectorAll('.js-type .js-type-line').forEach(line => {
        const charArray = line.innerText.split('');
        if (charArray.length > 0) {
          let html = '';
          let idx = 0;
          for (let char of charArray) {
            // const num = String(idx).padStart(3, '0');
            if (/^[ァ-ヴー・]$/.test(char)) {
              html += `<span class="ls_0 c-type__line__char js-type-char" data-type-index="${idx}">${char}</span>`
            } else {
              html += `<span class="c-type__line__char js-type-char" data-type-index="${idx}">${char}</span>`
            }
            idx += 1;
          }
          line.innerHTML = html;
          line.classList.remove('--pre-set');
        } else {
          line.classList.remove('--pre-set');
        }

      });

      // const isPortrate = window.innerWidth < window.innerHeight;
      const ww = Math.floor(window.innerWidth);
      const BASE_START_POSITION = ww > 768 ? 90 : 100;
      const BASE_END_POSITION = ww > 768 ? 85 : 95;


      document.querySelectorAll('.js-type').forEach(wrapper => {
        let type = 0;
        if (wrapper.classList.contains('--body')) {
          type = 1;
        }
        wrapper.querySelectorAll('.js-type-line').forEach((line, i) => {
          // const a = i === 0 ? -1 : 0;
          // const baseStart = BASE_START_POSITION - 5 * a;
          // const baseEnd = BASE_END_POSITION - 5 * a;
          let baseStart, baseEnd;
          // if (type === 1) {
          const delta = ww > 768 ? 4 : 2;
            baseStart = BASE_START_POSITION - delta * i;
            baseEnd = BASE_END_POSITION - delta * i;
          // } else {
          //   baseStart = BASE_START_POSITION;
          //   baseEnd = BASE_END_POSITION;
          // }
          line.querySelectorAll('.js-type-char').forEach((char, charIdx) => {

            let posStart, posEnd;
            // if (type === 1) {
              posStart = baseStart - 0.3 * charIdx;
              posEnd = baseEnd - 0.3 * charIdx;
            // } else {
            //   posStart = baseStart - 0.7 * charIdx;
            //   posEnd = baseEnd - 0.7 * charIdx;
            // }


            const animation = gsap.to(char, {
              color: '#000',
              ease: 'power1.out',
              // duration: 1,
              // delay: 1,
              scrollTrigger: {
                toggleActions: 'play pause resume reset',
                trigger: char,
                start: `top ${posStart}%`,
                end: `top ${posEnd}%`,
                scrub: true,
              }
            });

            // stArray.push(animation.scrollTrigger);

          });
        })
      })
    }

    // return stArray;

  }

// --- TOP CONCEPT ----
  if (document.querySelector('.js-concept-bg-wrapper .js-concept-bg .js-concept-rotate .p-front-concept__fixed__bg__circle')) {
    const wrapper = document.querySelector('.js-concept-bg-wrapper');
    const bg = wrapper.querySelector('.js-concept-bg');
    const rotate = wrapper.querySelector('.js-concept-rotate');

    ScrollTrigger.create({
      toggleActions: 'play pause resume reset',
      trigger: wrapper,
      start: `top top`,
      end: 'bottom bottom',
      onEnter: function() {
        bg.classList.add('--fixed');
      },
      onLeave: function() {
        bg.classList.add('--bottom');
        bg.classList.remove('--fixed');
      },
      onEnterBack: function() {
        bg.classList.add('--fixed');
        bg.classList.remove('--bottom');
      },
      onLeaveBack: function() {
        bg.classList.remove('--fixed');
      },
    });

    gsap.to(rotate, {
      rotation: 540,
      scrollTrigger: {
        trigger: wrapper,
        start: `top bottom`,
        end: 'bottom top',
        scrub: true,
      }
    })

    wrapper.querySelectorAll('.p-front-concept__fixed__bg__circle').forEach((circle, i) => {
      gsap.to(circle, {
        opacity: 1,
        ease: 'Power2.out',
        scrollTrigger: {
          trigger: wrapper,
          start: `top+=${Math.floor(-1 * 13.8 + 13.8 * i)}% top`,
          end: `top+=${13.8 * i}% top`,
          scrub: true,
          // markers: true,
        }
      })
    })
  }

// --- About Purpose-value-mission ----
  // if (document.querySelector('.js-philosophy-wrapper .js-philosophy-bg')) {
  //   const wrapper = document.querySelector('.js-philosophy-wrapper');
  //   wrapper.querySelectorAll('.js-philosophy-bg').forEach(bg => {

  //     ScrollTrigger.create({
  //       toggleActions: 'play pause resume reset',
  //       trigger: wrapper,
  //       start: `top top`,
  //       end: `bottom bottom`,
  //       onEnter: function() {
  //         bg.classList.add('--fixed');
  //       },
  //       onLeave: function() {
  //         bg.classList.remove('--fixed');
  //         bg.classList.add('--bottom');
  //       },
  //       onEnterBack: function() {
  //         bg.classList.remove('--bottom');
  //         bg.classList.add('--fixed');
  //       },
  //       onLeaveBack: function() {
  //         bg.classList.remove('--fixed');
  //       },
  //     });
  //   })


  // }

  // if (document.querySelector('.js-philosophy-bg-image') && document.querySelector('.js-philosophy-inner')) {
        
  //   try {
  //     for (let i = 0; i < 3; i++) {
  //       const image = document.querySelector(`.js-philosophy-bg-image.--0${i + 1}`);
  //       const inner = document.querySelector(`.js-philosophy-inner.--0${i + 1}`);
  //       if (!image || !inner) {
  //         throw new Error(`必要な要素が足りません / --0${i + 1}`);
  //       }
  //       ScrollTrigger.create({
  //         toggleActions: 'play pause resume reset',
  //         trigger: inner,
  //         start: `top bottom`,
  //         // markers: true,
  //         onEnter: function() {
  //           inner.classList.add('is-show');
  //           if (i > 0) {
  //             image.classList.add('is-show');
  //           }
  //         },
  //         onLeaveBack: function() {
  //           inner.classList.remove('is-show');
  //           if (i > 0) {
  //             image.classList.remove('is-show');
  //           }
  //         },
  //       });
  //     }
  //   } catch(err) {
  //     console.error(err);
  //   }
  // }

// --- Services Introduce Scroll ---
  const serviceSections = gsap.utils.toArray('.js-service-pc-item');
  const serviceNavButtons = gsap.utils.toArray('.js-service-pc-button');
  const scrollBar = document.querySelector('.js-service-pc-bar .--bar');
  const scrollContent = document.querySelector('.js-service-pc-scroll');

  if (serviceSections.length > 0 && serviceNavButtons.length > 0) {
    const header = document.querySelector('.l-header');
    const headerHeight = header ? header.offsetHeight : 0;

    const setActiveNav = (targetSlide) => {
      serviceNavButtons.forEach(button => {
        if (button.dataset.slide === targetSlide) {
          button.classList.add('is-active');
        }
        else {
          button.classList.remove('is-active');
        }
      });
    };

    serviceSections.forEach(section => {
      ScrollTrigger.create({
        trigger: section,
        start: 'top center',
        end: 'bottom center',
        onToggle: self => {
          if (self.isActive) {
            const slideId = section.dataset.slide;
            setActiveNav(slideId);
          }
        },
      });
    });

    serviceNavButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const targetSlide = button.dataset.slide;
        const targetSection = serviceSections.find(section => section.dataset.slide === targetSlide);

        if (targetSection) {
          gsap.to(window, {
            duration: 0.8,
            ease: 'power2.inOut',
            scrollTo: {
              y: targetSection,
              offsetY: headerHeight + 20 // 20pxの余白を追加
            }
          });
        }
      });
    });

    // --- Add scroll bar movement ---
    if (scrollBar && scrollContent) {
      gsap.to(scrollBar, {
        yPercent: (serviceSections.length - 1) * 100, // スクロールバーの移動
        ease: 'none',
        scrollTrigger: {
          trigger: scrollContent,
          start: 'top top',
          end: 'bottom bottom',
          scrub: true,
        },
      });
    }
  }

});

